var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sal-filter__checkboxes" }, [
    _vm.filter.title
      ? _c("div", { staticClass: "col-12" }, [
          _c("p", { staticClass: "filter__label group__label" }, [
            _vm._v(_vm._s(_vm.filter.title)),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter__group col-12" },
      _vm._l(_vm.availableOptions, function (option) {
        return _c("global-input-checkbox", {
          key: option.value || option,
          attrs: {
            value: _vm.isOptionSelected(option),
            label: option.title || option.value || option,
            disabled: _vm.$store.state.freeze,
            title: _vm.checkboxTitle(option),
          },
          on: {
            input: function ($event) {
              return _vm.toggleOption(option)
            },
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }